export default "__VITE_ASSET__DBDfPYG___"